export enum LoginPath {
  LOGIN = "/login",
  FIND_ID_AND_PASSWORD = "/login/find",
  FIND_PASSWORD_UPDATE = "/login/find/pwd-update",
}

export enum SignUpPath {
  SIGN_UP = "/signup",
  SIGN_UP_BUSINESS = "/signup/business", // 개인사업자 personal
  SIGN_UP_CORPORATE = "/signup/corporate", // 법인사업자 company
}

export enum AdminQuotationPath {
  ORDER = "/order",
  ORDER_DETAIL = "/order/details/:id",
  QUOTATION = "/quotes",
  QUOTATION_DETAIL = "/quotes/details/:id",
}

export enum SUPlatformPath {
  ADMIN = "/platform",
  DEPARTMENT = "/department",
  TIER = "/tier",
}

export enum SUAdminPath {
  PROFILE = "/profile",
  MY_PROFILE = "/profile/my-profile",
  DETAIL = "/profile/details",
  NOTICE = "/notification",
}

export enum AdminAdminPath {
  PROFILE = "/profile",
  MY_PROFILE = "/profile/my-profile",
  DETAIL = "/profile/details",
  NOTICE = "/notification",
}

export enum PartnerNotificationPath {
  NOTICE = "/notification",
}

export enum PartnerOrderPath {
  ORDER = "/order/product",
  CREATE_ORDER = "/order/create",
  COMPLETE_ORDER = "/order/complete",
}

export enum PartnerOrderManagePath {
  MANAGE_ORDER = "/order-manage",
  ORDER_DETAIL = "/order-manage/details/:id",
}

export enum PartnerQuotePath {
  QUOTES = "/quotes",
  QUOTES_DETAIL = "/quotes/details/:id",
}

export enum PartneAdminPath {
  MY_PROFILE = "/partner/my-profile",
}

export enum PartnerHomePath {
  HOME = "/",
}

export enum AdminPartnerPath {
  PARTNER = "/partner",
  DETAIL = "/partner/details",
}

export enum AdminItemPath {
  SINGLE_PRODUCT_CREATE = "/product/single-product/create",
  SINGLE_PRODUCT = "/product/single-product",
  SINGLE_PRODUCT_EDIT = "/edit",
  SINGLE_PRODUCT_DISCOUNTS = "/product/single-product/discounts",
  PACKAGE_PRODUCT_CREATE = "/product/package-product/create",
  PACKAGE_PRODUCT = "/product/package-product",
  PACKAGE_PRODUCT_EDIT = "/edit",
  PACKAGE_PRODUCT_DISCOUNTS = "/product/package-product/discounts",
}
